import { UnionStack } from "@masters-union/union-stack";

// Lazy singleton: UnionStack.init() throws synchronously when the key is
// missing, so creating the client at module load would white-screen every
// page that imports an uploader. Deferring to first use turns a missing
// key into a catchable upload error instead.
let client = null;

export const getUnionStackClient = () => {
  if (!client) {
    const apiKey = process.env.REACT_APP_UNIONSTACK_API_KEY;
    if (!apiKey) {
      throw new Error(
        "File upload is not configured: REACT_APP_UNIONSTACK_API_KEY is missing from .env"
      );
    }
    // skipConfigPrefetch: we never open the UnionStack picker UI, so skip
    // the branding/theme config fetch init() would otherwise fire.
    client = UnionStack.init({ apiKey, skipConfigPrefetch: true });
  }
  return client;
};
